import { useCallback, useRef } from 'react';
import { AdvancedEditorModel, AdvancedEditorItemTypeEnum } from '@diana/core';

/**
 * caches the index of the steps group to avoid full search whenever getting the steps group model item
 */
export const useFindStepsGroupModelItem = () => {
  const indexRef = useRef<number>(-1);

  const isMatch = useCallback((item: AdvancedEditorModel['items'][number]) => {
    return item.type === AdvancedEditorItemTypeEnum.Steps;
  }, []);

  return useCallback(
    (model: AdvancedEditorModel | null) => {
      if (model) {
        // find via index cache
        if (indexRef.current >= 0) {
          const cache = model.items[indexRef.current];
          if (cache && isMatch(cache)) {
            return cache;
          }
        }

        // full search
        indexRef.current = model.items.findIndex((item) => isMatch(item));
        const found = model.items[indexRef.current];
        if (found && isMatch(found)) {
          return found;
        }
      }

      return null;
    },
    [isMatch],
  );
};
